import { Box, Icon, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { debounce } from "lodash";
import { ColorPicker } from "mui-color";
import React from "react";
import { useTranslation } from "react-i18next";

const IconConfig = ({ 
  data, 
  icons, 
  setMarkerIcon,
  setMarkerIconColor
}) => {
  const { t } = useTranslation();
  const [iconColor, setIconColorPicker] = React.useState(data?.marker?.iconColor);

  // Créer le debounce dans le composant
  const debounceIconColor = React.useCallback(
    debounce((e) => setMarkerIconColor(e), 300),
    [setMarkerIconColor]
  );

  return (
    <Box id="icon" mb={2}>
      <InputLabel shrink>{t("/editor.gui.marker_icon")}</InputLabel>
      <Box display="flex" alignItems="center">
        <ColorPicker

          value={iconColor}
          onChange={(e) => {
            setIconColorPicker(`#${e?.hex}`);
            !e.error && debounceIconColor(`#${e?.hex}`);
          }}
          hideTextfield
        />
        <Select
      
          value={data?.marker?.icon?.value ?? "home"}
          onChange={(e) =>
            setMarkerIcon(
              icons.filter((i) => i.value === e.target.value)[0]
            )
          }
        >
          {icons.map((icon, i) => (
            <MenuItem key={i} value={icon?.value}>
              <Box display="flex" alignItems="center">
                {icon?.type === "svg" ? (
                  <Box
                    sx={{
                      backgroundColor: iconColor,
                      mask: `url(/icons/${icon?.file}) no-repeat center`,
                    }}
                  >
                    <img
                      width={35}
                      height={35}
                      src={`/icons/${icon?.file}`}
                      alt={icon?.name}
                      draggable={false}
                      style={{ opacity: 0 }}
                    />
                  </Box>
                ) : icon?.type ? (
                  <img
                    width={35}
                    height={35}
                    src={`/icons/${icon?.file}`}
                    alt={icon?.name}
                    draggable={false}
                  />
                ) : (
                  <Icon style={{ marginRight: 8, color: iconColor }}>
                    {icon.value}
                  </Icon>
                )}
                <Typography>{icon.name}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

export default IconConfig; 